import React from "react";
import PropTypes from "prop-types";
import AccountSettingsContainer from "./AccountSettingsContainer";
import AccountPeopleContainer from "./AccountPeopleContainer";
import { Route } from "react-router-dom";

const AccountSectionRouter = props => {
  const { account } = props;

  const renderSection = routerProps => {
    const { section } = routerProps.match.params;
    if (section === "settings") {
      return <AccountSettingsContainer account={account} />;
    }

    return <AccountPeopleContainer account={account} />;
  };

  return (
    <div>
      <Route path="/accounts/:accountId/:section?" render={renderSection} />
    </div>
  );
};
AccountSectionRouter.propTypes = {
  account: PropTypes.object.isRequired
};
export default AccountSectionRouter;



// WEBPACK FOOTER //
// ./src/AccountSectionRouter.js